import { Address } from "abitype";
import { VaultDetails } from "../types/vault";

// TODO: move this to data/vaults.ts or something

function getInvestorOrder(vaultAddr: string, investorAddr: string) {
  /*
  amount per epoch
  num epochs
  starting epoch
  shares minted
  shares burned
  shares current balance
  */
}

function formatVaultDetails(vaultAddr: Address | undefined, data: any): VaultDetails | undefined {
  if (vaultAddr && data) {
    return {
      vaultName: data[0].result,
      vaultSymbol: data[1].result,
      vaultAddress: vaultAddr,
      vaultDecimals: data[2].result,
      totalSupply: data[3].result,

      sourceTokenAddress: data[4].result,
      targetTokenAddress: data[5].result,

      swapperAddress: data[6].result,
      minAmountForSwap: data[7].result,

      epochLength: data[8].result,
      currentEpoch: data[9].result,

      entryFee: data[10].result,
      exitFee: data[11].result,
      executionFee: data[12].result,
    };
  }

  return undefined;
}

function getVaultTxs(vaultAddr: string, epoch: number, numTxs: number | undefined) {
  // TODO: TBI
  // dcaAmountPerEpoch
}

export { getInvestorOrder, formatVaultDetails, getVaultTxs };
